interface StepProps {
  number: number;
  label: string;
  status: "active" | "completed" | "upcoming";
  /** @deprecated use status instead */
  active?: boolean;
}

export const Step = ({ number, label, status, active }: StepProps) => {
  // backwards-compat: if only active is passed, derive status
  const resolvedStatus: "active" | "completed" | "upcoming" =
    status ?? (active ? "active" : "upcoming");

  const isActive = resolvedStatus === "active";
  const isCompleted = resolvedStatus === "completed";

  return (
    <div className="relative z-10 flex flex-col items-center gap-3">
      <div
        className={`w-11 h-11 rounded-full flex items-center justify-center transition-all
          ${isCompleted ? "shadow-[0px_10px_15px_0px_rgba(0,0,0,0.1),0px_4px_6px_0px_rgba(0,0,0,0.05)]" : ""}
          ${isActive ? "border-2 border-primary-purple bg-theme-step-circle-bg shadow-[0px_10px_15px_0px_rgba(0,0,0,0.1),0px_4px_6px_0px_rgba(0,0,0,0.05)]" : ""}
          ${!isActive && !isCompleted ? "border-2 border-theme-step-inactive-border bg-theme-step-circle-bg" : ""}`}
        style={
          isCompleted
            ? {
                background: "linear-gradient(146.5deg, #3b4fbd 8.49%, #6d28d9 50%, #9333ea 91.51%)",
              }
            : undefined
        }
      >
        {isCompleted ? (
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
            <path
              d="M1.5 6L6 10.5L14.5 1.5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <span
            className={`text-14 font-semibold ${isActive ? "text-theme-step-active-number" : "text-theme-step-inactive-number"}`}
          >
            {number}
          </span>
        )}
      </div>
      <span
        className={`text-12 font-medium ${isActive ? "text-theme-step-active-label" : "text-theme-step-inactive-label"}`}
      >
        {label}
      </span>
    </div>
  );
};
